import { default as color } from 'tinycolor2';
export class Colors {

  static knownColors: color[] = [];


  static clearKnownColors() {
    this.knownColors = [];
  }

  static setKnownColor(description: string, hex: string) {
    if (this.knownColors.findIndex(x => x.description == description) < 0) {
      let thisColor = color(hex);
      thisColor.setDescription(description);
      this.knownColors.push(thisColor);
    }
  }

  static getColorByDescription(description: string): color {
    let c = this.knownColors.find(x => x.getDescription() == description);
    if (!c) {
      const baseColorName = description.substring(0, description.indexOf('-'));
      const baseColor = this.knownColors.find(x => x.getDescription() == baseColorName);
      if (baseColor) {
        if (description.indexOf('contrasting') >= 0) {
          c = this.contrastingColor(baseColor);
        } else if (description.indexOf('lighter') >= 0) {
          const amount = +description.substring(description.lastIndexOf('-') + 1);
          c = this.lighten(baseColor, amount);
        } else if (description.indexOf('darker') >= 0) {
          const amount = +description.substring(description.lastIndexOf('-') + 1);
          c = this.darken(baseColor, amount);
        }
        else {

        }


      }
      c.setDescription(description);
      this.knownColors.push(c);
    }
    return c;
  }

  static lighten(c: color, percent: number): color {
    return color.mix(color(c.toHexString()), 'white', percent);
  }



  static darken(c: color, percent: number): color {
    return color.mix(color(c.toHexString()), 'black', percent);
  }

  static contrastingColor(c: color): color {
    const lum = c.getLuminance();
    if (lum <= .5) {
      return color('#fff');
    }
    else {
      return color('#000');
    }
    //return color.mostReadable(c, ['#333', '#fff'], {level:'AAA', size:'small'});
  }

  static autoColors(hex: string, combinationType: string): color[] {
    let baseColor = color(hex);
    switch (combinationType) {
      case 'analogous': {
        return baseColor.analogous(5, 15);
      }
      case 'complement': {
        return [baseColor.complement()];
      }
      case 'monochromatic': {
        return baseColor.monochromatic();
      }
      case 'splitComplement': {
        return baseColor.splitcomplement();
      }
      case 'triad': {
        return baseColor.triad();
      }
      case 'tetrad': {
        return baseColor.tetrad();
      }
      default: {
        return [baseColor];
      }
    }
  }
}

color.prototype.getDescription = function getDescription() { return this._description; }
color.prototype.setDescription = function setDescriptin(description: string) { this._description = description; return this; }
